import { TextStyle } from "react-native";
import * as Colors from "./colors";

export const italic = {
  fontFamily: "Basker",
  color: Colors.white,
};

export const weightBold = {
  fontFamily: "Stabil-Bold",
  color: Colors.white,
};

export const weightMedium = {
  fontFamily: "Stabil-Medium",
  color: Colors.white,
};

export const weightRegular = {
  fontFamily: "Stabil-Regular",
  color: Colors.white,
};

export const sectionTitle: TextStyle = {
  ...weightMedium,
  fontSize: 16,
  color: Colors.white,
  marginBottom: 10,
};

export const title: TextStyle = {
  ...weightRegular,
  fontSize: 18,
};

export const paragraph: TextStyle = {
  ...weightRegular,
  fontSize: 14,
};

export const cardTitle: TextStyle = {
  ...weightRegular,
  fontSize: 24,
  lineHeight: 26,
};
